/**
 * Ein Takt, der eine laufende Anzeige weiterzählen lässt.
 *
 * Eine Dauer wie „seit 4 min 36 s" wird beim Rendern **einmal** gerechnet.
 * Ohne einen Anlass zum Neuzeichnen bleibt sie stehen, und die Anzeige
 * behauptet nach zehn Minuten immer noch dieselbe Zahl. Das ist schlimmer als
 * keine Angabe: Sie sieht aus, als stimme sie.
 *
 * Der Haken liefert deshalb einen Wert, der sich sekündlich ändert, und zwar
 * **nur solange `aktiv`** — steht nichts mehr aus, gibt es auch keinen Grund,
 * die Seite jede Sekunde neu zu zeichnen.
 *
 * Rückgabe ist der Zeitstempel selbst, nicht ein Zähler: So kann der Aufrufer
 * damit rechnen, statt sich `Date.now()` nebenher zu holen — und der Wert ist
 * in Tests setzbar.
 */

import { useEffect, useState } from "react";

export function useSekundentakt(aktiv: boolean): number {
  const [jetzt, setzeJetzt] = useState(() => Date.now());

  useEffect(() => {
    if (!aktiv) return;
    /*
     * Beim Einschalten sofort einmal setzen: Sonst zeigt die erste Sekunde
     * noch den Stand von vor dem Umschalten.
     */
    setzeJetzt(Date.now());
    const takt = setInterval(() => setzeJetzt(Date.now()), 1_000);
    return () => clearInterval(takt);
  }, [aktiv]);

  return jetzt;
}
